import React from "react";
import { ConfirmationDialog } from "../../../assets/types/common";
import { FormatHelper } from "../../../assets/utils/helpers";
import { Constants } from "../../../assets/utils/lib/constants";
import { LoadingIndicator } from "../../../assets/vfx";
import Drawer from "../../../assets/vfx/drawer/drawer";
import DisplayData from "../../common/DisplayData/DisplayData";
import { PlanDto, SubscriptionDto } from "../../../services/dto";
import { VfxDialogProps } from "../../../assets/vfx/dialog/vfxDialogProps";

export interface SubscriptionViewProps {
  data?: SubscriptionDto;
  show: boolean;
  onHide: () => void;
  onEdit: () => void;
  onDeactivate: () => void;
}

export const SubscriptionView = (props: SubscriptionViewProps) => {
  const modalDialogProps: VfxDialogProps | undefined = props.data
    ?.deactivationDate
    ? undefined
    : new ConfirmationDialog().get(props.onDeactivate, "Deactivate", {
        Name: props.data?.name ?? Constants.emptyString,
      });

  return (
    <Drawer.View
      className="w-30"
      show={props.show}
      backdrop
      placement="end"
      scroll
      title="View Subscription"
      modalDialogProps={modalDialogProps}
      onHide={props.onHide}
      onEdit={props.onEdit}
      onDeactivate={
        props.data?.deactivationDate ? undefined : props.onDeactivate
      }
    >
      {!props.data ? (
        <LoadingIndicator isFullPage />
      ) : (
        <>
          <DisplayData text="Name" importedData={props.data.name} />
          <DisplayData
            text="Description"
            importedData={props.data.description ?? Constants.emptyString}
          />
          <DisplayData
            text="Activation Date"
            importedData={
              props.data?.activationDate
                ? FormatHelper.formatDate(props.data?.activationDate)
                : Constants.emptyString
            }
          />
          {props.data?.deactivationDate && (
            <DisplayData
              text="De-Activation Date"
              importedData={FormatHelper.formatDate(
                props.data?.deactivationDate
              )}
            />
          )}
        </>
      )}
    </Drawer.View>
  );
};
